const configStore = state => state.config;
const loading = state => state.config.loading;
const apiBaseUrl = state => state.config.apiBaseUrl;
const localizationSelector = state => state.config.localization;
const landingBaseUrl = state => state.config.landingBaseUrl;
const error = state => state.config.error;

export default {
  configStore,
  loading,
  apiBaseUrl,
  localizationSelector,
  landingBaseUrl,
  error
};
